module.exports = __webpack_public_path__ + "media/images/icons/bi-hand-thumbs-down-fill-3e994a769b522ceb506ca42941d5bfed.png";